import apiV2Service from '../api/api-v2.service';
import {MacroItem} from '../macros/macros.types';

const basePath = 'Conditions';

async function getOptionalValues({
  campaignId,
  versionId,
  nodeId,
  outputId,
  searchTerm,
  conditionKey,
}: {
  campaignId: number;
  versionId: number;
  nodeId: number;
  outputId: number;
  conditionKey: string;
  searchTerm: string;
}) {
  const url = `${basePath}/GetOptionalValues`;

  const {data} = await apiV2Service.executeGetRequest<MacroItem[]>(
    url,
    {
      campaignId,
      versionId,
      nodeId,
      ...(outputId && {outputId}),
      itemParamKey: conditionKey,
      searchPattern: searchTerm,
    },
    {},
  );

  return data;
}

async function searchFeedValues({
  feedIds,
  signalKey,
  valueContainsString,
  maxResults,
}: {
  feedIds: number[];
  signalKey: string;
  valueContainsString?: string;
  maxResults?: number;
}): Promise<{values: string[]; hasMore: boolean}> {
  const {data} = await apiV2Service.executePostRequest<{values: string[]; hasMore: boolean}>(
    `${basePath}/feeds/searchFeedSignalValues`,
    {},
    {
      feedIds,
      signalKey,
      valueContainsString,
      maxResults,
    },
  );

  return data;
}

const conditionsApi = {
  getOptionalValues,
  searchFeedValues,
};

export default conditionsApi;
